import { createFileRoute } from "@tanstack/react-router";
import { SiteFooter, SiteHeader } from "@/components/tools/ToolShell";

export const Route = createFileRoute("/pt-br/privacy-policy")({
  head: () => ({
    meta: [
      { title: "Política de Privacidade — Picamini.online" },
      {
        name: "description",
        content: "Política de privacidade do Picamini.online. Saiba como garantimos o processamento 100% local e privado no seu navegador.",
      },
    ],
    links: [
      { rel: "canonical", href: "https://picamini.online/pt-br/politica-de-privacidade" },
      { rel: "alternate", hrefLang: "en", href: "https://picamini.online/privacy-policy" },
      { rel: "alternate", hrefLang: "es", href: "https://picamini.online/es/politica-de-privacidad" },
      { rel: "alternate", hrefLang: "de", href: "https://picamini.online/de/datenschutzrichtlinie" },
      { rel: "alternate", hrefLang: "pt-BR", href: "https://picamini.online/pt-br/politica-de-privacidade" },
      { rel: "alternate", hrefLang: "x-default", href: "https://picamini.online/privacy-policy" },
    ],
  }),
  component: PtBrPrivacyPage,
});

function PtBrPrivacyPage() {
  return (
    <div className="min-h-screen bg-background flex flex-col font-sans">
      <SiteHeader lang="pt-BR" />

      <main className="flex-1 py-12 mx-auto max-w-4xl px-4 sm:px-6 lg:px-8 space-y-6">
        <h1 className="text-3xl font-extrabold text-foreground">Política de Privacidade</h1>
        <p className="text-sm text-muted-foreground">Última atualização: Setembro de 2026</p>

        <p className="text-base text-muted-foreground leading-relaxed">
          Sua privacidade é fundamental para nós no <strong>Picamini.online</strong>. Esta Política de Privacidade explica como lidamos com as informações dos usuários ao utilizar nosso site e ferramentas.
        </p>

        <h2 className="text-xl font-bold text-foreground pt-3">1. Processamento Local (Sem Upload de Arquivos)</h2>
        <p className="text-base text-muted-foreground leading-relaxed">
          Todas as ferramentas PDF e sorteadores do Picamini.online funcionam integralmente no seu próprio navegador de internet. Arquivos PDF, imagens ou listas de nomes inseridos no site <strong>nunca são enviados</strong> para nossos servidores nem armazenados em bancos de dados na nuvem.
        </p>

        <h2 className="text-xl font-bold text-foreground pt-3">2. Cookies e Análise</h2>
        <p className="text-base text-muted-foreground leading-relaxed">
          Podemos utilizar cookies técnicos estritamente necessários para salvar suas preferências de idioma e ferramentas. Não utilizamos cookies invasivos nem vendemos dados para terceiros.
        </p>

        <h2 className="text-xl font-bold text-foreground pt-3">3. LGPD (Lei Geral de Proteção de Dados)</h2>
        <p className="text-base text-muted-foreground leading-relaxed">
          Como nenhum dado pessoal identificável é coletado ou armazenado durante o uso das nossas ferramentas, o Picamini.online está em total conformidade com as diretrizes da LGPD no Brasil e do GDPR na União Europeia.
        </p>
      </main>

      <SiteFooter lang="pt-BR" />
    </div>
  );
}
